import { createWebRegistration } from '@reflex/plugin-api/create-web-registration';
import { CursorIcon } from './icons/CursorIcon';

export default createWebRegistration({
  icons: {
    CursorIcon,
  },
});
